const categories = {
  historicStoryConflicts: 'historicStoryConflicts',
  storyConflicts: 'storyConflicts',
  contacts: 'contacts',
  login: 'login',
  filter: 'filter',
  create: 'create',
  edit: 'edit',
  delete: 'delete',
  mirror: 'mirror',
  table: 'table',
  historic_mirror: 'historic_mirror',
  mirror_activity: 'mirror_activity',
};

const actions = {
  list: 'list',
  showDetails: 'showDetails',
  loginAttempt: 'loginAttempt',
  loginSuccessful: 'loginSuccessful',
  login: 'login',
  filterFolder: 'filterFolder',
  filterProgram: 'filterProgram',
  filterFromDate: 'filterFromDate',
  filterToDate: 'filterToDate',
  filterAuthor: 'filterAuthor',
  filterPlace: 'filterPlace',
  contactsButtonClicked: 'contactsButtonClicked',
  contactCardClicked: 'contactCardClicked',
  contactTemplateButtonClicked: 'contactTemplateButtonClicked',
  editClicked: 'editClicked',
  useEditDraft: 'useEditDraft',
  discardEditDraft: 'discardEditDraft',
  saveClicked: 'saveClicked',
  creationSuccessful: 'creationSuccessful',
  editSuccessful: 'editSuccessful',
  cancelClicked: 'cancelClicked',
  deleteClicked: 'deleteClicked',
  programmedActivitiesClicked: 'programmedActivitiesClicked',
  programListClicked: 'programListClicked',
  focusClicked: 'focusClicked',
  autoScrollClicked: 'autoScrollClicked',
  activityDetailClicked: 'activityDetailClicked',
  activityTabClicked: 'activityTabClicked',
  mirrorButtonClicked: 'mirrorButtonClicked',
  mirrorHistoricButtonClicked: 'mirrorHistoricButtonClicked',
  tableButtonClicked: 'tableButtonClicked',
  mirrorActivityCardClicked: 'mirrorActivityCardClicked',
};

export { categories, actions };
